var DataType;
(function (DataType) {
    DataType["Boolean"] = "boolean";
    DataType["DateTime"] = "date-time";
    DataType["Number"] = "number";
    DataType["Text"] = "text";
    DataType["Uuid"] = "uuid";
})(DataType || (DataType = {}));
var DataType$1 = DataType;

export { DataType$1 as default };
//# sourceMappingURL=DataType.js.map
